import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { gigInitialState } from "./states";
import axios from "axios";

const initialState = gigInitialState;

export const fetchGigAsync = createAsyncThunk(
  "gigs/Async",
  async (input, thunkApi) => {
    const { successCallback, errorCallback } = input;
    const { getState, rejectWithValue } = thunkApi;
    const { admin, gigs } = getState();

    const config = {
      headers: {
        authorization: `Bearer ${admin.accessToken}`
      }
    };

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_END_POINT}admin/getGigs?index=${gigs?.index}&limit=${gigs?.limit}&search=${gigs?.search}&activated=${gigs?.filters.approved}&new_gig=${gigs?.filters.new_gig}&reported=${gigs?.filters.reported}`,
        config
      );
      if (successCallback && typeof successCallback === "function") {
        successCallback();
      }
      return {
        gigs: response.data.content,
        totalCount: response.data.totalGigs
      };
    } catch (error) {
      errorCallback(error);
      return rejectWithValue(error.response.data);
    }
  }
);

export const GigSlice = createSlice({
  name: "gigs",
  initialState,
  reducers: {
    verified: (state, action) => {
      const { id, newData } = action.payload;
      const index = state.value.findIndex((bizz) => bizz._id === id);
      if (index !== -1) {
        state.value[index] = {
          ...state.value[index],
          ...newData
        };
      }
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
    setIndex: (state, action) => {
      state.index = action.payload;
    },
    setApproved: (state, action) => {
      state.filters.approved = action.payload;
    },
    setNewGig: (state, action) => {
      state.filters.new_gig = action.payload;
    },
    setReported: (state, action) => {
      state.filters.reported = action.payload;
    },
    setSearchText: (state, action) => {
      state.search = action.payload;
    },
    clearFilter: (state) => {
      state.index = 0;
      state.filters.approved = null;
      state.filters.new_gig = true;
      state.filters.reported = false;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchGigAsync.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchGigAsync.fulfilled, (state, action) => {
      state.isLoading = false;
      state.value = action.payload.gigs;
      state.totalCount = action.payload.totalCount;
    });
    builder.addCase(fetchGigAsync.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  }
});

export default GigSlice.reducer;
export const {
  verified,
  setIndex,
  setLimit,
  setApproved,
  setNewGig,
  clearFilter,
  setReported,
  setSearchText
} = GigSlice.actions;
